<div class="pane">
    <div class="pane__header pane__header--sticky bg-white">
        <div class="header">
            <h1 class="header__heading">
                Template
            </h1>
            <div class="header__actions">
                <button pButton label="Back" icon="pi pi-arrow-left" (click)="back()"></button>
            </div>
        </div>
    </div>
    <div class="pane__body">
        <p-panel styleClass="ui-panel--has-footer">
            <p-header>
                Template Details
            </p-header>
            <div class="p-grid">
                <div class="p-col-12">
                    <ripple-entity-details [entity]="teamType" [hideButtons]="true"
                        [generatorOptions]="generatorOptions" [fieldOrders]="fieldOrders"
                        (afterSave)="afterSave($event)" #ed></ripple-entity-details>
                </div>
                <div class="p-col-12">
                    <ripple-ms-team-file-explorer *ngIf="teamType.azureadobjectid"
                        [teamId]="teamTemplatesTeamAzureAdObjectId" [channelId]="teamType.azureadobjectid">
                    </ripple-ms-team-file-explorer>
                </div>
            </div>
           
            <p-footer>
              <ripple-button-list [buttons]="ed.splitButtons"></ripple-button-list>
            </p-footer>
          </p-panel>
        
    </div>
</div>